import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Fornecedor from '../fornecedor/fornecedor';
import Transportadora from '../transportadora/transportadora';

import {
	initFormItem
} from './pedidoActions';

class PedidoItemForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.formularioValues.excluir ? 'readOnly' : '';

		return (
			<div>

				{this.modalFornecedor()}

				{this.modalTransportadora()}

				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							
							<Field
								name='id_fornecedor'
								component={Select}
								label='Fornecedor' placeholder='Informe'
								options={this.props.listaFornecedor}
								cols='8 10 10 10'
								readOnly={readOnly} />
							
							{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_cadastro) &&
							<Grid cols='4 2 2 2'>
								<a class='btn btn-app bg-secondary' style={{ height: 67 }}
									onClick={() => this.setState({ ...this.state, modalFornecedor: true })}>
									<i class='fas fa-industry'></i> Cadastro
								</a>
							</Grid>}

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade' placeholder='Informe'
								cols='6 4 2 2'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor' placeholder='Informe'
								cols='6 4 2 2'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='id_forma_pagamento'
								component={Select}
								options={this.props.listaFormaPagamento}
								label='Forma de Pagamento' placeholder='Informe'
								cols='12 4 4 4'
								readOnly={readOnly} />
						</Row>

						<Row>							
							<Field
								name='id_transportadora'
								component={Select}
								label='Transportadora' placeholder='Informe'
								options={this.props.listaTransportadora}
								cols='8 10 10 10'
								readOnly={readOnly} />

							{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_cadastro) &&
							<Grid cols='4 2 2 2'>
								<a class='btn btn-app bg-secondary' style={{ height: 67 }}
									onClick={() => this.setState({ ...this.state, modalTransportadora: true })}>
									<i class='fas fa-truck'></i> Cadastro
								</a>
							</Grid>}

							<Field
								name='id_frete_tipo'
								component={Select}
								label='Tipo de Frete' placeholder='Informe'
								options={this.props.listaFreteTipo}
								cols='12 4 3 2'
								readOnly={readOnly} />

							{this.props.listaFreteTipo.filter(item => item.id == this.props.formularioValues.id_frete_tipo)[0]
								&& this.props.listaFreteTipo.filter(item => item.id == this.props.formularioValues.id_frete_tipo)[0].informa_valor &&
							<Field
								name='valor_frete'
								component={LabelAndInputNumber}
								label='Valor do Frete' placeholder='Informe'
								cols='6 4 2 2'
								readOnly={readOnly}
								mask={2} />}
								
							<LabelAndInputDate
								name='data_previsao_entrega'
								label='Previsão de Entrega' placeholder='Informe'
								cols='12 4 3 2'
								readOnly={readOnly}
								value={this.props.formularioValues.data_previsao_entrega}
								onChange={value => {
									this.props.initFormItem({
										...this.props.formularioValues,
										data_previsao_entrega: value
									})
								}} />
						</Row> 
						<Row>
							<Field
								name='nota_fiscal'
								component={LabelAndInput}
								label='Nota Fiscal' placeholder='Informe'
								cols='6 4 2 2'
								readOnly={readOnly} />
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.formularioValues.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Cancelar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.initFormItem(null)} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</div>
		);
    }

	modalFornecedor() {

		if (!this.state.modalFornecedor) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Fornecedor</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalFornecedor: false })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Fornecedor />
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => this.setState({ ...this.state, modalFornecedor: false })}>Fechar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalTransportadora() {

		if (!this.state.modalTransportadora) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Transportadora</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalTransportadora: false })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Transportadora />
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => this.setState({ ...this.state, modalTransportadora: false })}>Fechar</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

PedidoItemForm = reduxForm({form: 'pedidoItemForm', destroyOnUnmount: false})(PedidoItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('pedidoItemForm')(state),
	registro: state.pedido.registro,
	listaFornecedor: state.fornecedor.listaSelect,
	listaTransportadora: state.transportadora.listaSelect,
	listaFormaPagamento: state.formaPagamento.listaSelect,
	listaFreteTipo: state.pedido.listaFreteTipoSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	initFormItem
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoItemForm);
